import { render } from "./doubleBarChart.vue?vue&type=template&id=19f7d096&scoped=true"
import script from "./doubleBarChart.vue?vue&type=script&lang=js"
export * from "./doubleBarChart.vue?vue&type=script&lang=js"

import "./doubleBarChart.vue?vue&type=style&index=0&id=19f7d096&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f7d096"]])

export default __exports__